import { useState } from 'react';

import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { Cost } from '@r1-frontend/ui-react/experimental/purchase/cost';
import { WithTooltip } from '@r1-frontend/ui-react/experimental/tooltip';

import TooltipText from '~/src/features/payments-abn/components/WriteOffDetail/TooltipText';

import * as ST from './styled';

export interface IWriteOff {
    name: string,
    value: number,
    withTooltip?: boolean,
}

interface IProps {
    writeOffs: IWriteOff[],
}

const WriteOffDetail = ({ writeOffs }: IProps): JSX.Element | null => {
    const [isOpen, setIsOpen] = useState(false);

    if (!writeOffs.length) {
        return null;
    }

    return (
        <ST.DetailWrapper>
            {writeOffs.map(writeOff => (
                <ST.DetailRow key={writeOff.name}>
                    <ST.PaymentInfo>{writeOff.name}
                        {writeOff.withTooltip &&
                            <WithTooltip
                                isShown={isOpen}
                                onClose={() => setIsOpen(false)}
                                content={<TooltipText/>}
                            >
                                <ST.IconWrap
                                    onClick={() => setIsOpen(true)}
                                    role='button'
                                >
                                    <InfoCircleFlip size={16} />
                                </ST.IconWrap>
                            </WithTooltip>
                        }
                    </ST.PaymentInfo>
                    <ST.Separator/>
                    <ST.PaymentInfo data-test='pay-bonuses'>
                        <Cost>{writeOff.value}</Cost>
                    </ST.PaymentInfo>
                </ST.DetailRow>
            ))}
        </ST.DetailWrapper>
    );
};

export default WriteOffDetail;
